var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect, forwardRef } from 'react';
import { Switch as HeadlessSwitch } from '@headlessui/react';
import getIconSize from './private/utils/getIconSize';
import getSwitchSize from './private/utils/getSwitchSize';
import getTogglePosition from './private/utils/getTogglePosition';
import getToggleSize from './private/utils/getToggleSize';
import mergeClassnames from '../mergeClassnames/mergeClassnames';
const Switch = forwardRef((_a, ref) => {
    var { size = 'sm', checked = false, name, value, onChange, onBgColor, // deprecated
    offBgColor, // deprecated
    onIcon, offIcon, className } = _a, rest = __rest(_a, ["size", "checked", "name", "value", "onChange", "onBgColor", "offBgColor", "onIcon", "offIcon", "className"]);
    const [enabled, setEnabled] = useState(checked);
    const setEnabledHandler = (data) => {
        onChange && onChange(data);
        setEnabled(data);
    };
    useEffect(() => {
        if (typeof checked !== undefined && checked !== enabled)
            setEnabled(!!checked);
    }, [checked]);
    return (React.createElement(HeadlessSwitch, Object.assign({ ref: ref, name: name, value: value, checked: enabled, disabled: rest === null || rest === void 0 ? void 0 : rest.disabled, onChange: (data) => setEnabledHandler(data), className: mergeClassnames('block cursor-pointer rounded-full transition', getSwitchSize(size), enabled ? onBgColor : offBgColor, !onBgColor && !offBgColor && 'bg-beerus moon-checked:bg-piccolo', (rest === null || rest === void 0 ? void 0 : rest.disabled) && 'opacity-60 cursor-not-allowed select-none', className), "aria-readonly": rest === null || rest === void 0 ? void 0 : rest.disabled }, rest),
        React.createElement("span", { className: "block relative h-full w-full" },
            onIcon && (React.createElement("span", { className: mergeClassnames('z-1 absolute start-0 top-1/2 -translate-y-1/2 transition-opacity', 'text-goten', getIconSize(size), enabled ? 'opacity-100' : 'opacity-0'), "aria-hidden": "true" }, onIcon)),
            offIcon && (React.createElement("span", { className: mergeClassnames('z-1 absolute end-0 top-1/2 -translate-y-1/2 transition-opacity', 'text-bulma', getIconSize(size), enabled ? 'opacity-0' : 'opacity-100'), "aria-hidden": "true" }, offIcon)),
            React.createElement("span", { "aria-hidden": "true", className: mergeClassnames('slider z-5 absolute top-1/2 -translate-y-1/2 shadow-moon-sm pointer-events-none rounded-full', 'bg-goten transition-all', getToggleSize(size), enabled ? getTogglePosition(size) : 'start-0') }))));
});
export default Switch;
